import { render, staticRenderFns } from "./partner_list.vue?vue&type=template&id=72dfc0d1&scoped=true&"
import script from "./partner_list.vue?vue&type=script&lang=js&"
export * from "./partner_list.vue?vue&type=script&lang=js&"
import style0 from "./partner_list.vue?vue&type=style&index=0&id=72dfc0d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dfc0d1",
  null
  
)

export default component.exports